<template>
  <v-layout>
    <v-flex xs12 sm10 md8 class="form-container">
      <v-layout wrap>
        <v-flex xs12>
          <div v-if="$apollo.loading">
            <spinner />
          </div>
          <form v-else v-scroll-to-error>
            <div class="screen-title mb-32">
              <span>{{ adminText('workflowsAll.announcement_cf84a98', 'Announcement') }}</span>
            </div>
            <announcement-form
              :initial-values="form"
              :vs="$v"
              disabled
              @values="form=$event"
            />
            <main-button
              :text="adminText('workflowsAll.delete_f6fdbe4', 'Delete')"
              color="error"
              flat
              @click.prevent="showDeleteDialog = true"
            />
            <main-button :text="adminText('workflowsAll.cancel_77dfd21', 'Cancel')" flat @click.prevent="goBack" />
          </form>
        </v-flex>
      </v-layout>
    </v-flex>
    <delete-dialog
      :content="workflowLabel((adminText('workflowsAll.are_you_sure_you_want_to_delete_this_announce_1f1f244', 'Are you sure you want to delete this announcement? This operation cannot be undone.')))"
      :on-delete="deleteAnnouncement"
      :show.sync="showDeleteDialog"
      :title="adminText('workflowsAll.remove_announcement_793fe6e', 'Remove announcement')"
    />
  </v-layout>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
import { required } from 'vuelidate/lib/validators'
import DeleteDialog from './../shared/dialogs/delete-dialog.vue'
import AnnouncementForm from './announcement-form.vue'
import MainButton from './../shared/main-button'
import Spinner from './../shared/spinner'
import { deleteAnnouncement, getAnnouncement } from './../../http'
import { GET_ANNOUNCEMENT } from '../../graphql/announcement.graphql'


export default {
  mixins: [WorkflowDisplay],
  name: 'display-announcement-container',
  components: {
    AnnouncementForm,
    MainButton,
    Spinner,
    DeleteDialog,
  },
  props: {
    eventId: {
      default: null,
      type: String,
    },
    id: {
      default: null,
      type: String,
    },
  },
  validations() {
    return {
      form: {
        title: { required },
        text: { required },
      },
    }
  },
  data: () => ({
    showDeleteDialog: false,
    announcement: {},
    form: {},
  }),
  apollo: {
    getEventAnnouncement: {
      query: GET_ANNOUNCEMENT,
      variables() {
        return {
          eventId: this.eventId,
          id: this.id,
        }
      },
      manual: true,
      result({ loading, data }) {
        if (!loading) {
          const { getAnnouncement: announcement } = data
          this.form = announcement
        }
      },
    },
  },
  methods:{
    async deleteAnnouncement() {
      await deleteAnnouncement({
        eventId: this.eventId,
        id: this.id})
      this.goBack()
    },
  },
}
</script>

<style>
.form-container {
  margin-right: 30px;
}
</style>
